import { Lead, LeadSystemStage } from '@jms/model';

import { defineStatusTag } from '../../shared/define.status.tag';

// Single source of Lead stage colour. One function feeds both the manifest's board-card tag style
// and the manage surface header's `lead.stageTag` deriver, so the two can never drift. 'neutral'
// doubles as the runtime fallback so an unknown/legacy stage reads as New rather than untoned.
export const leadStageTag = defineStatusTag<LeadSystemStage, Lead>({
  [LeadSystemStage.New]: 'neutral',
  [LeadSystemStage.InProgress]: 'brand',
  [LeadSystemStage.Qualified]: 'success',
  [LeadSystemStage.Disqualified]: 'error',
}, 'neutral');
